import { ThemeColors } from 'src/shared/ui/consts-styles'
import styled from 'styled-components'

export const ChangeTitle = styled.span`
    font-size: 0.85rem;
    color: ${ThemeColors.getGrayColor(0.5)};
`
export const SpanDataItem = styled.span`
    color: ${ThemeColors.getGrayColor(1)};
`
export const Container = styled.div`
    display: flex;
    flex-direction: column;
`
export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    align-items: center;
`
export const ButtonClose = styled.div`
    box-shadow: none;
    outline: none;
    margin: 0;
    border: none;
    cursor: pointer;
    width: 1.9rem;
    height: 100%;

    & svg {
        fill: ${ThemeColors.getGrayColor(0.4)};
    }

    &:hover > svg {
        fill: ${ThemeColors.black};
    }
`

export const H = styled.div`
    display: flex;
    flex-direction: column;
`

export const HistoryContainer = styled.div`
    height: 100%;
    padding: 5px;
`
export const HistoryRow = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    padding: 5px;
    box-sizing: border-box;
`

export const DescriptionSpan = styled.div`
    /*    font-size: 17px;*/
    color: ${ThemeColors.getGrayColor(0.4)};
    font-weight: bold;
    padding: 0.5rem 0;
`
export const ButtonSpan = styled.span`
    font-weight: 400;
    color: ${ThemeColors.getGrayColor(0.5)};
`
